<template></template>
<script>
export default {
  name: "contragent-search-history-saver",
  props: {
    selected_search_results: {
      type: Array,
      //array of objects: { email, name }
    },
  },
  methods: {
    save() {
      this.search_loading = true;
      var formData = new FormData();
      formData.append("org_residency", "");
      formData.append("company_address", "");
      formData.append("company_main_sphere", "");
      formData.append("org_name", this.selected_search_results.name);
      formData.append("search_other", "");
      axios.post(
        window.base +
          "/contract/searchContr?contract_id=" +
          this.$route.params.id,
        formData,
      );
    },
  },
  mounted() {
    this.save();
  },
};
</script>
